import React, { useState } from "react";
import { BackLogoIconButton } from "../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { MobileTopHeader } from "../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import { TopTextReusableComponent } from "../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { SliderReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import Media from "react-media";
import { TextField } from "@material-ui/core";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import isEmpty from "../../../../store/validation/is-Empty";
import { update_restaurant_pos_restId } from "../../../../store/actions/authAction";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function PosWithId(props) {
  const history = useHistory();

  const [restId, setRestId] = useState("");
  const [menuSharingCode, setMenuSharingCode] = useState("");

  const handlesaveRestId = () => {
    const formData = {
      pos: {
        posId: props?.onboarding?.primaryPointOfSale?._id,
        restId: restId,
        menusharingcode: menuSharingCode,
      },
    };
    props.update_restaurant_pos_restId(props?.onboarding?._id, formData);
    history.push("/healthsenitation");
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div
            id="onboarding-scrollbar"
            className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left"
          >
            <Media query="(min-width: 992px)">
              <div className="col-12">
                <BackLogoIconButton
                  displayBackText={true}
                  displayArrow={true}
                  backButtonClicked={"/pointofsale"}
                />
              </div>
            </Media>
            <Media query="(max-width: 991px)">
              <MobileTopHeader link={true} onLink={"/pointofsale"} />
            </Media>
            {/* <div className="display-toggle-stepup-button">
            <RightSidePannel selectedTab={this.state.selectedTab} />
          </div> */}
            <div className="onboarding_process_screen-button-map">
              {/* <MapSetupScreenTwo /> */}
              <div>
                <TopTextReusableComponent
                  headingText="Log in With Rest ID"
                  //headingParagraph="This system is for simply put, every time a customer makes a purchase at your store they’re completing a point of the sale transaction."
                />
              </div>
              {/* <Form noValidate onSubmit={this.onHandleSubmit}>
              {this.renderDressCodeFields()}
            </Form> */}
              <div style={{ width: "50%" }}>
                <div>
                  <NewInputText
                    extraClass="m-0"
                    displayLabel={true}
                    controlId="name"
                    variant="outlined"
                    name="name"
                    labelText={"Restaurant ID"}
                    inputType="text"
                    onChange={(e) => {
                      setRestId(e.target.value);
                    }}
                    value={restId}
                    required="required"
                  />
                </div>
              </div>

              <div style={{ width: "50%" }} className="mt-2">
                <div>
                  <NewInputText
                    extraClass="m-0"
                    displayLabel={true}
                    controlId="name"
                    variant="outlined"
                    labelText={"Menu Sharing Code"}
                    name="name"
                    inputType="text"
                    onChange={(e) => {
                      setMenuSharingCode(e.target.value);
                    }}
                    value={menuSharingCode}
                    required="required"
                  />
                </div>
              </div>
              <div
                className="onboarding-map-setup-screen-autodetect-button"
                style={{ position: "fixed" }}
              >
                {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
                <ReusableOnboardingLink
                  buttonTitle="Back Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                  buttonText="Back"
                  link="/pointofsale"
                />
                <ReusableOnboardingButton
                  buttonTitle="Next Button"
                  buttonClass={
                    "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                  }
                  buttonText="Next"
                  onClick={handlesaveRestId}
                  //   buttonType={actionButton === false ? "button" : "submit"}
                />
                {/* </div> */}
              </div>
            </div>
          </div>
          <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
            <SliderReusableComponent
              displayBarButton={true}
              displayHamburger={true}
              selectedProgressBarOne="active"
              paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-04.svg")}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

//export default PosWithId

PosWithId.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  point_of_sale: state.category.point_of_sale,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
  update_restaurant_pos_restId,
})(withRouter(PosWithId));
